let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("aHG2I"), load("bJvam"), load("iClbn")]).then(() => parcelRequire('8KP6j'));